import { EditOutlined } from "@ant-design/icons";
import { TProfileEdit } from "@utils/Interfaces";

const CertificateEdit: React.FC<TProfileEdit> = ({
  data,
  handleChangeValue,
}) => {
  return (
    <div className="CertificateEdit">
      <div className="item">
        <div className="edit-action">
          <EditOutlined />
        </div>
        <div className="title">
          Microsoft Certified: Azure Developer Associate
        </div>
        <div className="time-range">ISSUED 12/2022</div>
        <div className="certificate">Microsoft</div>
      </div>
      <div className="item">
        <div className="edit-action">
          <EditOutlined />
        </div>
        <div className="title">
          Meta Backend Developer Professional Certificate
        </div>
        <div className="time-range">ISSUED 12/2021</div>
        <div className="certificate">Apple</div>
      </div>
    </div>
  );
};

export default CertificateEdit;
